module.exports = __webpack_public_path__ + "static/media/KNOXLogo2.298989dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/KNOXLogo2.svg
// module id = 1168
// module chunks = 0